import React from "react";
import { Section } from "./Elements/Section";
import { Card } from "./Elements/Card";

const models = [
  { t: "Fixed‑scope projects", d: "Clear deliverables, timeline, and budget." },
  { t: "Dedicated pods", d: "Cross‑functional teams operating as your squad." },
  { t: "Staff augmentation", d: "Specialists to extend your team quickly." },
  {
    t: "Advisory & audits",
    d: "Architecture reviews, security, and cost control.",
  },
];

export const Engagement = () => {
  return (
    <Section
      id="engagement"
      eyebrow="Flexible models"
      title="Engagement options"
      subtitle="Pick what suits your stage and constraints."
    >
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {models.map((m) => (
          <Card key={m.t}>
            <h3 className="font-semibold text-gray-900">{m.t}</h3>
            <p className="mt-1 text-sm text-gray-600">{m.d}</p>
          </Card>
        ))}
      </div>
    </Section>
  );
};
